import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import {
	AppIcon,
	ButtonBase,
	Icon
} from "client/Components";
import { isNil, isNotNil } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./SelectIcon.module.less";
import classNames from "classnames";
import { AppColorViewModel } from "client/Api/Apps/common";
import { getReactColorAttributes } from "client_legacy/ndaw/appColor";
import { localize } from "client_legacy/ndaw/culture";
import { useCallbackWithoutArguments } from "client/Hooks";

export type SelectIconProps = {
	id?: string;
	image: AppImageDisplayInfo | nil;
	imageBackgroundColor?: OptionalModel<AppColorViewModel | nil>;
	trackingId: string;
	onClick?: () => void;
};

export const SelectIcon = (props: SelectIconProps): ReactElement => {
	const {
		id,
		image,
		imageBackgroundColor = { isSet: false},
		trackingId,
		onClick: onClickFromProps
	} = props;

	const onClick: (() => void) | undefined = useCallbackWithoutArguments(onClickFromProps);

	const { colorClass, colorStyle } = imageBackgroundColor.isSet
		? getReactColorAttributes(imageBackgroundColor.value)
		: { colorClass: "", colorStyle: undefined };

	return (
		<ButtonBase
			trackingId={trackingId}
			id={id}
			disabled={isNil(onClick)}
			className={classNames(
				styles.root,
				{
					[styles.root_hasImage]: isNotNil(image),
					[styles.root_appColor]: imageBackgroundColor.isSet
				},
				colorClass
			)}
			style={colorStyle}
			onClick={onClick}
		>

			{isNotNil(image)
				? (
					<>
						<div className={styles.preview}>
							<AppIcon
								value={image}
								color={
									imageBackgroundColor.isSet
										? "inherit"
										: undefined
								}
							/>
						</div>
						<div className={styles.hover}>
							<div className={styles.text}>
								{localize("_Change")}
							</div>
						</div>
					</>
				)
				: (
					<>
						<div>
							<Icon
								value={{
									kind: "font",
									name: "upload",
									color: "primary"
								}}
								size="extra-large"
							/>
						</div>

						<div className={styles.text}>
							{localize("_SelectFile")}
						</div>
					</>
				)
			}
		</ButtonBase>
	);
};
SelectIcon.displayName = "SelectIcon";